import { RouteComponentProps, Route, withRouter } from 'react-router';
import AppLayout from './layouts/BasicLayout/Layout/Layout';
import { applicationState } from './states/applicationState';
import commonResources from './common/resources/common';
import { connect } from 'react-redux';
import { ErrorBoundary } from '@arkas/core';
import { FormattedMessage } from 'react-intl';
import OidcCallback from './components/Oidc/OidcCallback';
import React from 'react';
import { User } from 'oidc-client';
import userManager from './oidc/userManager';

const Routes = React.lazy(() => import('./Routes'));

const PlaceHolder: React.SFC<{}> = () => {
  return (
    <div>
      <FormattedMessage id={commonResources.yukleniyor.id} />
    </div>
  );
};

type AppProps = RouteComponentProps<{}> & {
  user: User;
  isLoadingUser: boolean;
};

const App: React.SFC<AppProps> = props => {
  const { user, isLoadingUser, location } = props;

  if (isLoadingUser || !location) {
    return <PlaceHolder />;
  }

  if (location.pathname === '/oidc/signin-callback') {
    return <Route path="/oidc/signin-callback" component={OidcCallback} />;
  }

  userManager.getUser().then(user => {
    if (!user || user.expired) {
      userManager.signinRedirect({
        data: { path: location.pathname }
      });
      return <PlaceHolder />;
    }
  });

  if (!user || user.expired) {
    return <PlaceHolder />;
  }

  userManager.clearStaleState();

  return (
    <ErrorBoundary>
      <AppLayout>
        <React.Suspense fallback={null}>
          <Routes />
        </React.Suspense>
      </AppLayout>
    </ErrorBoundary>
  );
};

const mapStateToProps = (state: applicationState) => {
  return {
    user: state.oidc.user,
    isLoadingUser: state.oidc.isLoadingUser
  };
};

export default withRouter<Partial<AppProps>>(connect(mapStateToProps)(App));
